var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"daily-clicks",attrs:{"id":"daily-clicks"}},[_c('analytics-table',{attrs:{"group_id":"date","show_title":true,"show_clicks":true,"analytics":_vm.analytics}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }